import React from "react";

export default function CreateVehicleFine() {
  return (
    <div className="createvehiclefine-container my-4">
      <div className="col-md-12">
        <div className="special-header panel-white-all">
          <h4 className="page-title">Create Vehicle Fine</h4>
        </div>

        <form>
          <div className="row create-vehicle-fine-row">
            <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="vehicleno" className="form-label"> Vehicle Number <span className="text-danger">*</span></label>
              <select id="vehicleno" className="form-control createfine-form-select" >
                <option>Select</option>
                <option>MH21WE9021</option>
                <option>MH02WE0002</option>
                <option>MH03BR8934</option>
              </select>
            </div>
            <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="driver" className="form-label"> Driver <span className="text-danger">*</span> </label>
             <select id="driver" className="form-control createfine-form-select" >
                <option>Select</option>
                <option>Super Fast</option>
                <option>Ola Driver</option>
                <option>Rapido Driver</option>
              </select>
              </div>

            <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="reason" className="form-label">Reason<span className="text-danger">*</span>  </label>
              <input type="text" id="reason" className="form-control createfine-form-control" placeholder="Enter fuel quantity" />
            </div>

            <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="status" className="form-label"> Status <span className="text-danger">*</span> </label>
              <input type="text" id="status" className="form-control createfine-form-control" placeholder="Enter amount" />
            </div>

            <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="amount" className="form-label"> Amount <span className="text-danger">*</span> </label>
              <input type="text" id="amount" className="form-control createfine-form-control" placeholder="Enter amount" />
            </div>

            <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="date" className="form-label">Date<span className="text-danger">*</span></label>
              <input  type="date"  id="date"  className="form-control createfine-form-control" />
            </div>

            <div className="col-lg-12 col-md-12 mt-3 d-flex justify-content-end">
              <button type="submit" className="btn custom-btn">
                Create
              </button>
            </div>
            
          </div>
        </form>
      </div>
    </div>
  
    
  );
}
